"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorP2PFieldView = void 0;
var core_shared_1 = require("@ikegps/core-shared");
var index_1 = require("../../../i18n/index");
var field_info_1 = require("../../field.info/field.info");
var vector_manual_field_view_1 = require("./vector.manual.field.view");
exports.VectorP2PFieldView = {
    viewInline: function (field) {
        return field_info_1.FieldInfo.viewVectorInline(field.value);
    },
    hasDetail: function (field) {
        return true;
    },
    viewDetail: function (field) {
        var collection = field.collection;
        var captures = field.getCaptures();
        var p2pMeasurement = core_shared_1.MultiPoint.Points(captures);
        var stats = [
            { name: index_1.T.DISTANCE_VERTICAL, value: Math.abs(p2pMeasurement.vertical) },
            { name: index_1.T.DISTANCE_HORIZONTAL, value: p2pMeasurement.horizontal }
        ];
        return field_info_1.FieldInfo.viewCaptures(collection, captures, stats);
    },
    viewEdit: function (field, ctrl) {
        return (0, vector_manual_field_view_1.viewVectorManualEdit)(field, ctrl);
    }
};
//# sourceMappingURL=vector.p2p.field.view.js.map